/*
 * @Author: your name
 * @Date: 2021-03-01 14:32:44
 * @LastEditTime: 2023-11-02 09:40:22
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\programEditing\mutations.js
 */
import * as types from './mutation-types';

function swap(vdrList, vi1, vi2) {
  let vdrZIndex = vdrList[vi2].zIndex;
  vdrList[vi2].zIndex = vdrList[vi1].zIndex;
  vdrList[vi1].zIndex = vdrZIndex;

  let vdrValue = vdrList[vi2];
  vdrList[vi2] = vdrList[vi1];
  vdrList[vi1] = vdrValue;
}

const mutations = {
  // 编辑页面缩放比例
  [types.RATIO_COUNT](state, count) {
    state.ratio = count;
  },
  // 窗口存储修改列表
  // 添加
  [types.VDR_LIST_ADD](state, vdrChild) {
    state.vdrList.push(vdrChild);
  },
  // 修改
  [types.VDR_LIST_EDIT](state, vdrChild) {
    state.vdrList[state.vdrIndex] = vdrChild;
  },
  // 删除
  [types.VDR_LIST_DEL](state, idx) {
    let index = state.vdrList.findIndex(vdrItem => vdrItem.idx === idx);
    let vdr = state.vdrList.splice(index, 1);
    // 将index减一
    for (let i = index + 1; i < state.vdrList.length; i++) {
      state.vdrList[i].zIndex -= 1;
    }
    state.vdrList.forEach((vdrIten, index) => {
      if (vdrIten.idx === vdr.idx) {
        state.vdrIndex = index;
      }
    })
    !state.vdrList[state.vdrIndex] && (state.vdrIndex = state.vdrList.length - 1);
  },
  // 清除
  [types.VDR_LIST_CLEAR](state) {
    state.vdrList = [];
  },
  // 当前激活窗口
  [types.VDR_INDEX](state, index) {
    state.vdrIndex = index;
  },
  // 当前激活窗口子元素
  // [types.VDR_CHILD_INDEX](state, childIndex) {
  //   state.vdrChildIndex = childIndex;
  // },
  // 修改层级
  [types.VDR_WIN_ZINDEX](state, zNum) {
    let vdrList = state.vdrList;
    // 当前选中窗口zIndex
    let zIndex = vdrList[state.vdrIndex].zIndex;
    let index = zIndex + zNum;
    let length = vdrList.length;
    if (index >= 0 && index < length) {
      let vdrIten = vdrList[state.vdrIndex];
      let subtract = 0;
      let sIndex = 0;
      if (zNum < 0) {
        // 找出一个随意差值
        vdrIten = vdrList.find((item, i) => {
          sIndex = i;
          return (zIndex - item.zIndex) > 0;
        });
        subtract = zIndex - vdrIten.zIndex;
        for (let i = 0; i < length; i++) {
          if ((zIndex - vdrList[i].zIndex) < subtract) {
            (zIndex - vdrList[i].zIndex) > 0 && (vdrIten = vdrList[i], sIndex = i);
          }
        }
      }
      if (zNum > 0) {
        vdrIten = vdrList.find((item, i) => {
          sIndex = i;
          return (item.zIndex - zIndex) > 0;
        });
        subtract = zIndex - vdrIten.zIndex;
        for (let i = 0; i < length; i++) {
          if ((vdrList[i].zIndex - zIndex) < subtract) {
            (vdrList[i].zIndex - zIndex) > 0 && (vdrIten = vdrList[i], sIndex = i);
          }
        }
      }
      // console.log(vdrIten);
      // let vdrZIndex = vdrIten.zIndex;
      // vdrIten.zIndex = vdrList[state.vdrIndex].zIndex
      // vdrList[state.vdrIndex].zIndex = vdrZIndex;
      // let zIndex = state.vdrList[state.vdrIndex].zIndex;
      swap(vdrList, state.vdrIndex, sIndex);
      state.vdrIndex = sIndex;
    }
  },
  // 最上层
  [types.VDR_WIN_CEIL](state) {
    // console.log(state);
    // let vdrList = state.vdrList;
    // // 当前选中窗口zIndex
    // let vdrIten = vdrList[0];
    // vdrList.forEach(item => {
    //   if (item.zIndex > vdrIten.zIndex) {
    //     vdrIten = item;
    //   }
    // });
    // let vdrZIndex = vdrIten.zIndex;
    // vdrIten.zIndex = vdrList[state.vdrIndex].zIndex
    // vdrList[state.vdrIndex].zIndex = vdrZIndex;

    let vdrList = state.vdrList;
    let length = vdrList.length;
    let vdrIndex = state.vdrIndex;
    vdrList[vdrIndex].zIndex = length - 1;
    for (let i = vdrIndex + 1; i < length; i++) {
      vdrList[i].zIndex -= 1;
      let vdrItem = vdrList[i];
      vdrList[i] = vdrList[i - 1]
      vdrList[i - 1] = vdrItem;
    }

    state.vdrIndex = length - 1;
  },
  // 最下层
  [types.VDR_WIN_FLOOR](state) {
    // console.log(state);
    // let vdrList = state.vdrList;
    // // 当前选中窗口zIndex
    // let vdrIten = vdrList[0];
    // vdrList.forEach((item) => {
    //   if (item.zIndex < vdrIten.zIndex) {
    //     vdrIten = item;
    //   }
    // });
    // let vdrZIndex = vdrIten.zIndex;
    // vdrIten.zIndex = vdrList[state.vdrIndex].zIndex
    // vdrList[state.vdrIndex].zIndex = vdrZIndex;

    let vdrList = state.vdrList;
    let vdrIndex = state.vdrIndex;
    vdrList[vdrIndex].zIndex = 0;

    for (let i = vdrIndex - 1; i > -1; i--) {
      vdrList[i].zIndex += 1;
      let vdrItem = vdrList[i];
      vdrList[i] = vdrList[i + 1]
      vdrList[i + 1] = vdrItem;
    }

    state.vdrIndex = 0;
  },
  // 设置容器窗口尺寸
  [types.VDR_WINDOW_SIZE](state, size) {
    state.vdrWindowSize = size;
  },
  // 设置窗口铺满方式
  [types.VDR_WIN_FULL](state, size) {
    Object.keys(size).forEach((key) => {
      state.vdrList[state.vdrIndex][key] = parseInt(size[key]);
    });
    const { w, h } = state.vdrList[state.vdrIndex];
    state.vdrList[state.vdrIndex].wicket.forEach((wicketItem) => {
      wicketItem.w = w;
      wicketItem.h = h;
    });
  },
  // 设置窗口对齐方式
  [types.VDR_WIN_ALIGN](state, position) {
    Object.keys(position).forEach((key) => {
      state.vdrList[state.vdrIndex][key] = parseInt(position[key]);
    });
  },
  // 设置是否开始截图
  [types.IS_SAVE_PROGRAM](state, status) {
    state.isSaveProgram = status;
  },
  // 设置窗口背景网格
  [types.VDR_GRID_SET](state, grids) {
    state.grids = grids;
  },

};

export default mutations;